export const deafaultFilter = {
	page: 1,
	page_size: 10,
	search: '',
}
